import React, { createElement } from 'react';
// Module-level side effect: runs BEFORE React mounts.
// Purpose: inject preconnect + preload tags so critical asset downloads start
// in parallel with HTML/CSS/JS parsing. Invisible to users; safe for live campaigns.
if (typeof document !== 'undefined') {
  const head = document.head;
  const ensureLink = (rel: string, href: string, attrs: Record<string, string> = {}) => {
    if (head.querySelector(`link[rel="${rel}"][href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
    head.appendChild(link);
  };
  // Preconnect to font + image CDNs so DNS/TLS is done before requests
  ensureLink('preconnect', 'https://fonts.googleapis.com');
  ensureLink('preconnect', 'https://fonts.gstatic.com', {
    crossorigin: ''
  });
  ensureLink('preconnect', 'https://cdn.magicpatterns.com');
  // Preload the LCP image — responsive: mobile preloads the smaller mockup, desktop preloads the original.
  // Uses imagesrcset + imagesizes so the preload scanner picks the correct version before <picture> renders.
  // Without this, mobile would preload the big desktop image and lose the savings.
  if (!head.querySelector('link[rel="preload"][data-lcp="hero"]')) {
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.setAttribute('as', 'image');
    preload.setAttribute('fetchpriority', 'high');
    preload.setAttribute('type', 'image/webp');
    preload.setAttribute('data-lcp', 'hero');
    preload.setAttribute('imagesrcset', 'https://cdn.magicpatterns.com/uploads/v68hK4CPKStUhPKx3o2iUK/mocap_futbool_%282%29_%281%29.webp 768w, https://cdn.magicpatterns.com/uploads/buXD3KcbWgFp1MZw1bc7Qq/ChatGPT_Image_12_may_2026,_16_36_32-Photoroom.webp 1600w');
    preload.setAttribute('imagesizes', '(max-width: 768px) 90vw, 800px');
    // Fallback href for older browsers that ignore imagesrcset on preload (they'll preload desktop)
    preload.href = 'https://cdn.magicpatterns.com/uploads/buXD3KcbWgFp1MZw1bc7Qq/ChatGPT_Image_12_may_2026,_16_36_32-Photoroom.webp';
    head.appendChild(preload);
  }
}
export function PreloadAssets() {
  return null;
}